import { render, staticRenderFns } from "./modify_password.vue?vue&type=template&id=7353b08f&scoped=true&"
import script from "./modify_password.vue?vue&type=script&lang=js&"
export * from "./modify_password.vue?vue&type=script&lang=js&"
import style0 from "./modify_password.vue?vue&type=style&index=0&id=7353b08f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353b08f",
  null
  
)

export default component.exports